// extracted by mini-css-extract-plugin
export default {"result_body":"style_result_body__9F3kE","result_container":"style_result_container__4vkcA","table_body":"style_table_body__oifKC","pageTitle":"style_pageTitle__xFdsT"};